export function defaultGetNodeKey({ treeIndex }) {
  return treeIndex;
}

// Cheap hack to get the text of a react object
function getReactElementText(parent) {
  if (typeof parent === 'string') {
    return parent;
  }

  if (
    typeof parent !== 'object' ||
    !parent.props ||
    !parent.props.children ||
    (typeof parent.props.children !== 'string' &&
      typeof parent.props.children !== 'object')
  ) {
    return '';
  }

  if (typeof parent.props.children === 'string') {
    return parent.props.children;
  }

  return parent.props.children
    .map((child) => getReactElementText(child))
    .join('');
}

// Search for a query string inside a node property
function stringSearch(key, searchQuery, node, path, treeIndex) {
  const query = searchQuery.toLocaleLowerCase();
  if (typeof node[key] === 'function') {
    // Search within text after calling its function to generate the text
    return (
      String(node[key]({ node, path, treeIndex }))
        .toLocaleLowerCase()
        .indexOf(query) > -1
    );
  } else if (typeof node[key] === 'object') {
    // Search within text inside react elements
    return (
      getReactElementText(node[key]).toLocaleLowerCase().indexOf(query) > -1
    );
  }

  // Search within string
  return node[key] && String(node[key]).toLocaleLowerCase().indexOf(query) > -1;
}

export function caseInsensitiveSearchMethod({
  node,
  path,
  treeIndex,
  searchQuery,
}) {
  if (!searchQuery || searchQuery.trim().length === 0) {
    return false;
  }
  return stringSearch('title', searchQuery, node, path, treeIndex);
}
